<template>
  <b-row class="profile" v-if="user != null" :class="$store.isRTL ? 'text-right' : ''">
    <b-col>
      <b-row
        class="page-header sticky-top bg-white border-bottom scrolled"
      >
        <div class="d-flex align-items-center w-100 px-3">
          <b-link to="/">
            <i :class="$store.isRTL ? 'bi-arrow-right' : 'bi-arrow-left'" />
          </b-link>
          <h5 class="p-0 my-3 mx-2 flex-grow-1 overflow-hidden">
            <ui-username :user="user" :asLink="false" :bold="false" />
          </h5>

          <b-link :to="'/messages/' + user.id" class="mx-1 my-1 d-flex flex-column justify-content-center text-center" v-if="!isOwner">
            <ui-icon name="plus" classes="icon-medium"></ui-icon>
            <span class="link-text">{{ $t('general.send-message-user') }}</span>
          </b-link>
          <!-- <b-link @click.prevent="tip" class="mx-2 my-1 d-flex flex-column" v-if="!isOwner && $store.state.paymentEnabled" >
            <ui-icon name="coin" classes="icon-medium"></ui-icon>
            <span class="link-text">{{ $t('general.send-tip') }}</span>
          </b-link> -->
        </div>
      </b-row>
      <b-row>
        <div class="bg-light cover w-100 position-relative">
          <b-img :src="user.cover" v-if="user.cover != null" />
        </div>
        <div class="subprofile w-100 d-flex">
          <div class="avatar position-relative ml-3 rounded-circle">
            <b-avatar
              :src="user.avatar"
              :text="user.initials"
              :to="user.url"
              size="100px"
            />
          </div>
        </div>
      </b-row>
      <b-row class="px-3 mt-3 d-block border-bottom pb-3 overflow-hidden">
        <ui-username :user="user" :asLink="false" />
        <div class="text-muted small username">
          {{ "@" + user.username }}
        </div>
        <div class="bio nl2br" v-if="user.bio">{{ user.bio }}</div>
        <div v-if="user.location" class="text-muted small">
          {{ user.location }}
        </div>
      </b-row>
      <b-row
        class="px-3 mt-3 d-block border-bottom pb-3"
        v-if="!user.isSubscribed && !user.isFollowed && !isOwner && user.isFree"
      >
        <h5 class="mb-3">{{ $t("general.subscription") }}</h5>
        <b-button variant="primary" block @click.prevent="subscribe">
          {{$t("general.signup-free")}}
        </b-button>
      </b-row>
      <!-- <b-row
        class="px-3 mt-3 d-block border-bottom pb-3"
        v-if="user.isSubscribed && !user.isFree"
      >
        <h5 class="mb-3">{{ $t("general.subscription") }}</h5>
        <b-button variant="primary" block @click.prevent="subscribe">
          {{$t("general.unsubscribe")}}
        </b-button>
      </b-row>
      <b-row
        class="px-3 mt-3 d-block border-bottom pb-3"
        v-if="user.isFollowed && user.isFree"
      >
        <b-button variant="primary" block @click.prevent="subscribe">
          {{$t("general.unfollow")}}
        </b-button>
      </b-row> -->
      <b-row
        class="px-3 mt-3 d-block border-bottom pb-3"
        v-if="
          !isOwner &&
          !user.isSubscribed &&
          !user.isFree &&
          user.bundles.length > 0
        "
      >
        <h5 class="mb-3">{{ $t("general.subscription-bundles") }}</h5>
        <b-button
          variant="primary"
          block
          @click.prevent="subscribe(item)"
          v-for="(item, index) in user.bundles"
          :key="index"
        >
          {{ $t("general.get-x-months-for-y", item.title) }}
        </b-button>
      </b-row>
      <ui-posts v-model="posts" />
    </b-col>
  </b-row>
</template>
<style lang="scss" scoped>
.link-text{
  font-family: 'almoni-tzar', sans-serif;
  margin-top: -3px;
}
.profile {
  .page-header {
    top: -56px;
    margin-bottom: -56px;
    transition: top 0.2s;
    color: white;
    .btn,
    a:not(.dropdown-item) {
      padding: 0;
      color: white;
    }
    &.scrolled {
      top: 0;
      margin-bottom: 0;
      color: black;
      .btn,
      a {
        color: black;
      }
    }
  }
  .cover {
    height: 180px;
    &:after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      pointer-events: none;
      content: "";
      z-index: 3;
    }
    img {
      -o-object-fit: cover;
      object-fit: cover;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
  .avatar {
    margin-top: -50px;
    z-index: 3;
  }
}
</style>
<style scoped lang="scss">
@import "~@/assets/scss/_variables.scss";
.nav-tabs .nav-link {
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: $secondary;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: $primary;
  border-color: $primary;
}
</style>
<script>
import Post from "../models/Post";
import User from "../models/User";
import UiPosts from "../ui/UiPosts.vue";
import Payment from "../models/Payment";
import UiUsername from "../ui/UiUsername.vue";
import UiIcon from '../ui/UiIcon.vue';

export default {
  components: { UiPosts, UiUsername, UiIcon },
  data: function () {
    return {
      user: null,
      posts: [],
      scrollPosition: null,
      page: 1,
      hasMore: false,
      isLoading: false,
      postsType: Post.TYPE_ACTIVE
    };
  },
  computed: {
    isScrolled: function () {
      return this.scrollPosition >= 180;
    },
    isOwner: function () {
      return this.user.id == this.$store.state.currentUser.id;
    },
    username: function () {
      return this.$route.params.username;
    },
    types: function () {
      return {
        active: Post.TYPE_ACTIVE,
        scheduled: Post.TYPE_SCHEDULED,
        expired: Post.TYPE_EXPIRED,
      };
    },
  },
  watch: {
    username: function (oldV, newV) {
      if (oldV && newV && oldV != newV) {
        this.reset();
        this.loadUser();
      }
    },
  },
  mounted() {
    this.loadUser();
    this.readUrlParams();
    window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    updatePosts(type) {
      this.postsType = type;
      this.reset();
      this.loadPosts();
    },
    reset() {
      this.isLoading = false;
      this.hasMore = false;
      this.page = 1;
      this.posts = [];
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      const scrollPosition = window.innerHeight + window.scrollY;
      if (
        document.body.offsetHeight &&
        scrollPosition &&
        document.body.offsetHeight - scrollPosition <= 1000 &&
        !this.isLoading &&
        this.hasMore
      ) {
        this.loadMore();
      }
    },
    loadUser() {
      this.$get(
        "/users/" + this.username,
        (data) => {
          this.user = new User(data);
          this.loadPosts();
        },
        (errors) => {
          console.log(errors);
        }
      );
    },
    loadPosts() {
      this.isLoading = true;
      this.$get(
        "/posts/user/" +
          this.user.id +
          "?page=" +
          this.page +
          "&type=" +
          this.postsType,
        (data) => {
          let posts = [...this.posts];
          for (let obj of data.data) {
            posts.push(new Post(obj));
          }
          this.posts = posts;
          this.hasMore = data.next_page_url != null;
          this.isLoading = true;
        },
        (errors) => {
          console.log(errors);
        }
      );
    },
    loadMore() {
      if (this.hasMore) {
        this.page = this.page + 1;
        this.loadPosts();
      }
    },
    copyLink() {
      const link = `${process.env.VUE_APP_APP_URL}${this.user.url}`;
      this.$copyText(link);
      this.$bvToast.toast(this.$t("general.link-copied"), {
        autoHideDelay: 2000,
        title: this.$t("general.link"),
        solid: true,
        toaster: "b-toaster-bottom-left",
      });
    },
    readUrlParams(){
      let params = this.$route.query;

      if(!params.success || params.success == 0){
        this.$bvToast.toast(params.message, {
          autoHideDelay: 2000,
          title: this.$t("general.error"),
          solid: true,
          variant: 'danger',
          toaster: "b-toaster-top-left",
        });
      }else{
        this.$bvToast.toast(params.message, {
          autoHideDelay: 2000,
          title: this.$t("general.success"),
          solid: true,
          variant: 'success',
          toaster: "b-toaster-top-left",
        });
      }

      this.$router.replace({'query': null});
    },
    addToList(user) {
      this.$store.state.addToListUser = user;
    },
    subscribe(bundle) {
      if (this.user.isFree) {
        this.$post(
          "/follow/" + this.user.id,
          {},
          () => {
            this.reset();
            this.loadUser();
          },
          (errors) => {
            console.log(errors);
          }
        );
      } else {
        this.$buyItem({
          type: Payment.TYPE_SUBSCRIPTION_NEW,
          user: this.user,
          bundle: bundle,
          success: (data)=>{
            this.reset();
            this.loadUser();
            this.loadPosts();
            this.$nextTick(() => {
              this.$bvToast.toast(data.message, {
                autoHideDelay: 2000,
                variant: 'success',
                title: this.$t("general.success"),
                solid: true,
                toaster: "b-toaster-top-left",
                noCloseButton: true
              });
            });
            
          }
        });
      }
    },
    tip() {
      this.$buyItem({
        type: Payment.TYPE_TIP,
        user: this.user,
        success: (data) => {
          this.$bvToast.toast(this.$t('general.sent_x_tip', [data.message.tip_amount]), {
              autoHideDelay: 2000,
              variant: 'success',
              title: this.$t("general.success"),
              solid: true,
              toaster: "b-toaster-top-left",
              noCloseButton: true
          });
        }
      });
    },
  },
};
</script>
